(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/matchview/horizontal-matchlist.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/matchview/horizontal-matchlist.js');
"use strict";


class HorizontalMatchlist extends React.Component {
  componentDidMount() {
    const {
      currentTab,
      setCurrentTab
    } = this.props;
    const eventSwiperItemWidth = Math.round(window.innerWidth / 3);
    const eventSwiperItems = document.querySelector('.js-swipe-item');
    eventSwiperItems.css('width', eventSwiperItemWidth);
    svs.challenge.slider = new svs.components.Slider(document.getElementById('scrollist'), {
      center: true,
      slideOnClick: true,
      startIndex: currentTab ? currentTab - 1 : 0
    });
    svs.challenge.slider.on('change:after', tab => {
      setCurrentTab(tab.index + 1);
    });
  }
  render() {
    const {
      drawEvents,
      currentTab
    } = this.props;
    const matches = drawEvents.map((event, i) => {
      const sportType = event.match.sport ? event.match.sport.type : null;
      const trotting = sportType === svs.components.sport.sportTypes.SportTypes.Trotting;
      let className = 'horizontal-matchlist-item js-swipe-item';
      if (i == currentTab - 1) {
        className += ' active';
      }
      if (drawEvents[i].participantType === 'Player') {
        return React.createElement("a", {
          className: "block js-slider-slide slider-slide",
          href: "1",
          key: event.eventNumber
        }, React.createElement("section", {
          className: className
        }, React.createElement("div", null, event.match.participants[0].shortName), React.createElement("div", null, event.match.participants[1].shortName)));
      }
      return React.createElement("a", {
        className: "block js-slider-slide slider-slide",
        href: "1",
        key: event.eventNumber
      }, React.createElement("section", {
        className: className
      }, React.createElement("div", null, trotting ? "".concat(event.outcomes[0].description, ". ").concat(event.match.participants[0].mediumName) : event.match.participants[0].mediumName), React.createElement("div", null, trotting ? "".concat(event.outcomes[2].description, ". ").concat(event.match.participants[1].mediumName) : event.match.participants[1].mediumName)));
    });
    return React.createElement("div", {
      className: "horizontal-matchlist challenge slider-container",
      id: "scrollist"
    }, React.createElement("div", {
      className: "swipe-wrap js-slider-wrapper slider-wrapper"
    }, matches));
  }
}
svs.challenge.HorizontalMatchlist = HorizontalMatchlist;

 })(window);